import { baseUrl } from '../../network'

export const getAccountFiltersUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/accounts/filters`
export const getAccountsUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/accounts`
export const createAccountUrl = (companyId: number) => baseUrl + `api/company/${companyId}/accounts`
export const deleteAccountUrl = (accountId: number) => baseUrl + `api/accounts/${accountId}`
export const getAccountsOverviewUrl = (comapnyId: number) => baseUrl + `api/company/${comapnyId}/accounts/overview`